import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { browserPerformanceTimeOrigin } from '@sentry/utils';
import './node_modules/rrweb/es/rrweb/packages/rrweb/src/entries/all.js';
import { WINDOW } from './constants.js';
import record from './node_modules/rrweb/es/rrweb/packages/rrweb/src/record/index.js'; // Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type

var ENTRY_TYPES = _defineProperty({
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry
}, 'largest-contentful-paint', createLargestContentfulPaint);

function createPerformanceEntries(entries) {
  return entries.map(createPerformanceEntry).filter(Boolean);
}

function createPerformanceEntry(entry) {
  if (ENTRY_TYPES[entry.entryType] === undefined) {
    return null;
  }

  return ENTRY_TYPES[entry.entryType](entry);
}

function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((browserPerformanceTimeOrigin || WINDOW.performance.timeOrigin) + time) / 1000;
} // TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function createPaintEntry(entry) {
  var duration = entry.duration,
      entryType = entry.entryType,
      name = entry.name,
      startTime = entry.startTime;
  var start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name: name,
    start: start,
    end: start + duration
  };
} // TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function createNavigationEntry(entry) {
  // TODO: There looks to be some more interesting bits in here (domComplete, domContentLoaded)
  var entryType = entry.entryType,
      name = entry.name,
      duration = entry.duration,
      domComplete = entry.domComplete,
      startTime = entry.startTime,
      transferSize = entry.transferSize,
      type = entry.type; // Ignore entries with no duration, they do not seem to be useful and cause dupes

  if (duration === 0) {
    return null;
  }

  return {
    type: "".concat(entryType, ".").concat(type),
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name: name,
    data: {
      size: transferSize,
      duration: duration
    }
  };
} // TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function createResourceEntry(entry) {
  var entryType = entry.entryType,
      initiatorType = entry.initiatorType,
      name = entry.name,
      responseEnd = entry.responseEnd,
      startTime = entry.startTime,
      encodedBodySize = entry.encodedBodySize,
      transferSize = entry.transferSize; // Core SDK handles these

  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }

  return {
    type: "".concat(entryType, ".").concat(initiatorType),
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name: name,
    data: {
      size: transferSize,
      encodedBodySize: encodedBodySize
    }
  };
} // TODO: type definition!
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type


function createLargestContentfulPaint(entry) {
  var duration = entry.duration,
      entryType = entry.entryType,
      startTime = entry.startTime,
      size = entry.size;
  var start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name: entryType,
    start: start,
    end: start + duration,
    data: {
      duration: duration,
      size: size,
      // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      nodeId: record.mirror.getId(entry.element)
    }
  };
}

function createMemoryEntry(memoryEntry) {
  var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit,
      totalJSHeapSize = memoryEntry.totalJSHeapSize,
      usedJSHeapSize = memoryEntry.usedJSHeapSize; // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead

  var time = new Date().getTime() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit: jsHeapSizeLimit,
        totalJSHeapSize: totalJSHeapSize,
        usedJSHeapSize: usedJSHeapSize
      }
    }
  };
}

export { createMemoryEntry, createPerformanceEntries };